import { makeStyles } from 'tss-react/mui'
import { Theme } from '@mui/material'
import { paletteColors } from 'primsell-shared-layer/styles/theme-material/palette'

export const useStyles = makeStyles()((theme: Theme) => ({
  dialogPaperRoot: {
    position: 'relative',
    marginTop: '10px',
    borderRadius: '20px 20px 0 0',
    background: theme.palette.text.secondary,

    '&::before': {
      content: "''",
      position: 'fixed',
      top: 0,
      width: 'calc(100% - 16px)',
      height: '100%',
      borderRadius: '20px 20px 0 0',
      background: '#2C2C2D',
      margin: '0 8px 0 8px',
      zIndex: -1,
    },
  },
  dialogSign: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '100%',
    width: '100%',
    padding: '16px 0',
  },
  dialogSignText: {
    display: 'flex',
    justifyContent: 'flex-start',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '10px',
    padding: '0 16px',
  },
  dialogSignTextTitle: {
    fontSize: 32,
    color: theme.palette.text.primary,
    marginTop: theme.spacing(13),
  },
  dialogSignTextDescription: {
    fontSize: 16,
    color: theme.palette.text.primary,
    textAlign: 'center',
  },
  dialogSignBtns: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    marginBottom: '16px',
    padding: '16px',
    gap: 16,
  },
  cancelButton: {
    color: paletteColors.white,
    height: 40,
    width: '100%',
    border: `1px solid ${theme.palette.primary.main}`,
    '&:hover': {
      boxShadow: 'none',
      backgroundColor: theme.palette.primary.main,
    },
    boxShadow: 'none',
    '&$disabled': {
      backgroundColor: `${theme.palette.primary.main} !important`,
      opacity: 0.4,
    },
  },
}))
